import React, { useState } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import UploaderSection from '../UploaderSection';
import * as sharedStyles from '../../FullTextBulkUploader.module.css';
import {
  Icon,
  IconList,
  MenuButton,
  MenuLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Text,
} from 'components/core';

const ReferenceManagerHelper = () => {
  const SUPPORT_URL = 'https://support.covidence.org';
  const ENDNOTE_URL = `${SUPPORT_URL}/help/how-to-use-endnote-to-bulk-upload-full-texts`;
  const ZOTERO_URL = `${SUPPORT_URL}/help/how-to-use-zotero-to-upload-full-texts`;

  const [findPdfsIcon, setFindPdfsIcon] = useState<IconDefinition>(
    IconList.light.faChevronDown
  );

  const updateFindPdfsIcon = (isOpen: boolean) => {
    setFindPdfsIcon(
      isOpen ? IconList.light.faChevronUp : IconList.light.faChevronDown
    );
  };

  return (
    <UploaderSection>
      <Text className={sharedStyles.StepText}>
        Step 2: Find missing PDFs using your reference manager
      </Text>
      <MenuTrigger
        onMenuOpenChange={updateFindPdfsIcon}
        className={sharedStyles.StepAction}
      >
        <MenuButton variant="outline">
          Learn how to find PDFs
          <Icon icon={findPdfsIcon} />
        </MenuButton>
        <MenuPopover placement="bottom start">
          <MenuList>
            <MenuLink to={ENDNOTE_URL} external={true}>
              <Text>Endnote guide</Text>
            </MenuLink>
            <MenuLink to={ZOTERO_URL} external={true}>
              <Text>Zotero guide</Text>
            </MenuLink>
          </MenuList>
        </MenuPopover>
      </MenuTrigger>
    </UploaderSection>
  );
};

export default ReferenceManagerHelper;
